module.exports = __webpack_public_path__ + "static/fast100-64a527e9ca1d3bb0d6a36be0a06bd16e.jpg";